<template>
    <v-tabs>
        <v-tab>
            Info
        </v-tab>
        <v-tab>
            Schedules
        </v-tab>
        <v-tab-item>
            <EditEventForm v-bind:id="id"></EditEventForm>
        </v-tab-item>
        <v-tab-item>
            <EditEventSchedules v-bind:id="id" v-bind:event="eventTemplate">
            </EditEventSchedules>
        </v-tab-item>
    </v-tabs>
</template>
<script>
import EditEventForm from '@/components/EditEventForm';
import EditEventSchedules from '@/components/EditEventSchedules';
import { db } from '@/services/firebase';

export default {
    name: 'EditEvent',
    props: ['id'],
    components: {
        EditEventForm,
        EditEventSchedules
    },
    firestore () {
      return {
        eventTemplate: db.collection('event_templates').doc(this.id)
      }
    },
}
</script>